// extracted by mini-css-extract-plugin
export var rssCategories = "rss-parser-module--rss-categories--66894";
export var rssContent = "rss-parser-module--rss-content--1325f";
export var rssImage = "rss-parser-module--rss-image--b4e6d";
export var rssTitle = "rss-parser-module--rss-title--28c51";